const easeInOutQuad = (t, b, c, d) => {
  t /= d/2;
  if (t < 1) {
    return c/2*t*t + b
  }
  t--;
  return -c/2 * (t*(t-2) - 1) + b;
};

export function scrollTo(to:number, duration: number, callback?:Function ) {
    const start = document.body.scrollTop;
    let currentTime = 0;
    const change = to-start;
    const increment = 20;

    const doScroll = () => {
        currentTime += increment;
        const newPos = easeInOutQuad(currentTime, start, change, duration);
        document.body.scrollTop = newPos;

        if(currentTime < duration) {
            window.requestAnimationFrame(doScroll);
        } else {
            if(typeof(callback) !== 'undefined') callback.call(null);
        }
    };
    doScroll();
}